import { Plugin } from '@ckeditor/ckeditor5-core';
import RecorderUtils from '../recorderutils';
import { createRecorderViewElement } from './utils';
import {
    downcastRecorderAttribute,
    downcastRecorderWidth,
    downcastRecorderAlignment,
    downcastRecorderResized,
    downcastRecorderFlip,
    upcastRecorderAlignment,
    upcastRecorderWidth,
    upcastRecorderResized,
} from './converters';

export default class RecorderBlockEditing extends Plugin {
    static get requires() {
        return [ RecorderUtils ];
    }

    static get pluginName() {
        return 'RecorderBlockEditing';
    }

    init() {
        const editor = this.editor;
        const schema = editor.model.schema;
        const conversion = editor.conversion;
        const recorderUtils = editor.plugins.get('RecorderUtils');

        // ===============================
        // Schema
        // ===============================
        schema.register('recorderBlock', {
            isObject: true,
            isBlock: true,
            allowWhere: '$block',
            allowAttributes: [
                'src',
                'type',
                'controls',
                'width',
                'alignment',
                'resized',
            ]
        });

        // ===============================
        // Downcast → modelo -> vista
        // ===============================
        conversion.for('dataDowncast').elementToElement({
            model: 'recorderBlock',
            view: (modelElement, { writer }) =>
                createRecorderViewElement(writer, modelElement)
        });

        conversion.for('editingDowncast').elementToElement({
            model: 'recorderBlock',
            view: (modelElement, { writer }) =>
                recorderUtils.toRecorderWidget(
                    createRecorderViewElement(writer, modelElement),
                    writer
                )
        });

        // atributos dinámicos
        conversion.for('downcast').add(
            downcastRecorderAttribute(recorderUtils, 'recorderBlock', 'src')
        );
        conversion.for('downcast').add(downcastRecorderWidth('recorderBlock'));
        conversion.for('downcast').add(
            downcastRecorderAlignment('recorderBlock')
        );
        conversion.for('downcast').add(downcastRecorderResized('recorderBlock'));

        // ===============================
        // Upcast → vista -> modelo
        // ===============================
        // atributos
        conversion.for('upcast').add(upcastRecorderAlignment('recorderBlock'));
        conversion.for('upcast').add(upcastRecorderWidth('recorderBlock'));
        conversion.for('upcast').add(upcastRecorderResized('recorderBlock'));

        // bloque principal: <figure class="recorder">
        conversion.for('upcast').elementToElement({
            view: {
                name: 'figure',
                classes: 'recorder'
            },
            model: (viewElement, { writer }) => {
                const mediaElement = Array.from(viewElement.getChildren()).find(
                    child =>
                        child.is('element', 'audio') ||
                        child.is('element', 'video')
                );

                if (!mediaElement) {
                    return null;
                }

                // Capturamos ancho en figure, nunca en <video>/<audio>
                const width = viewElement.getStyle('width') || 'Original';

                return writer.createElement('recorderBlock', {
                    type: mediaElement.name,
                    src: mediaElement.getAttribute('src') || null,
                    width: width,
                    alignment: viewElement.hasClass('recorder-style-align-center')
                        ? 'center'
                        : viewElement.hasClass('recorder-style-align-left')
                        ? 'left'
                        : viewElement.hasClass('recorder-style-align-right')
                        ? 'right'
                        : null,
                    resized: viewElement.hasClass('recorder_resized')
                        ? true
                        : null
                });
            }
        });
    }
}
